import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { ModalBaseComponent } from '../add-or-edit-org-modal/modal-base.component';
import { DataService } from '../data/data.service';
import { Student } from '../data/student';
import { ActivitySequenceDetails, AssignedStudent, AssignmentDetails } from '../data/assignment-details';

@Component({
  selector: 'app-add-or-edit-assignment-modal',
  templateUrl: './add-or-edit-assignment-modal.component.html',
  styleUrls: ['./add-or-edit-assignment-modal.component.css']
})
export class AddOrEditAssignmentModalComponent extends ModalBaseComponent<AssignmentDetails> implements OnInit {
  @Input() organizationId: number;
  @Input() students: Student[];

  assignedStudents: { student: Student, include: boolean }[];
  assignedStudentsOld: { student: Student, include: boolean }[];

  validator = {
    StartDate: -1,
    EndDate: -1,
    DateRange: -1
  };
  showDateMessage: boolean = false;
  startDatePlaceholder: any;

  editAssignmentData: AssignmentDetails;

  initializeNewData(): void {
    this.data = new AssignmentDetails();
    this.data.ActivitySequence = new ActivitySequenceDetails();
    this.data.ActivitySequence.Activities = [];
    this.data.AssignedStudents = [];
    this.data.OrganizationID = this.organizationId;
    let today = new Date();
    this.data.StartDate = `${today.getFullYear()}-${(today.getMonth()+1).toString().padStart(2, "0")}-${(today.getDate()).toString().padStart(2, "0")}`
    this.validator = {
      StartDate: -1,
      EndDate: -1,
      DateRange: -1
    };
    this.assignedStudents = this.students.map(student => ({ student: student, include: false}));
    this.saveAssignedStudents();
    this.validateStartDate();
  }
  isInputValid(): boolean {
    return this.data.OrganizationID 
      && !this.invalidName()
      && this.validator.StartDate === 1
      && this.validator.EndDate === 1
      && this.validator.DateRange === 1
  }
  saveEdit(): void {
    this.editAssignmentData.ActivitySequence.Name = this.data.ActivitySequence.Name;
    this.editAssignmentData.EndDate = this.data.EndDate;
    this.editAssignmentData.StartDate = this.data.StartDate;
    this.editAssignmentData.AssignedStudents =
      this.assignedStudents.filter(s => s.include)
      .map(s => ({StudentID: s.student.ID}));
    this.modal.close();
  }
  saveNew(): void {
    this.isWaiting = true;

    this.data.AssignedStudents = 
      this.assignedStudents.filter(s => s.include)
      .map(s => ({StudentID: s.student.ID}));

    this.dataService.upsertClassAssignment(this.data
      ).subscribe({
        next: o => {
          if (o) {
            Swal.fire({            
              title: "Saved!",
              text: "The assignment has been created",
              type: "success",
              showConfirmButton: false,
              timer: 1000
            }).then(() => {
              this.dataRefresh.emit(o);
              this.modal.close();
            });
          }
          this.isWaiting = false;
        },
        error: err => Swal.fire("Oops!", err.message, "error")
      });

  }

  openForNew() {
    this.wasOpenedForEdit = false;
    this.submitButtonText = 'Save';
    this.modalHeader = "New Assignment"
    this.initializeNewData();
    this.open(this.content);
  }

  openForEdit(assignment: AssignmentDetails) {
    this.editAssignmentData = assignment;
    super.openForEdit(assignment);
    this.submitButtonText = "Done";
    this.modalHeader = "Edit Assignment";
    this.assignedStudents = this.students.map(student => ({ 
        student: student, 
        include: assignment.AssignedStudents.some(s => s.StudentID === student.ID)
      }));
    this.saveAssignedStudents();
    this.validateStartDate();
    this.validateEndDate();
  }

  constructor(modalService: NgbModal, dataService: DataService) { super(modalService, dataService); }

  invalidName(): boolean {
    return !this.data.ActivitySequence.Name;
  }

  validateStartDate() {
    this.validator.StartDate = this.data.StartDate && !isNaN(new Date(this.data.StartDate).getDate()) ? 1 : 0;
    this.validateDateRange();
  }

  validateEndDate() {
    this.validator.EndDate = this.data.EndDate && !isNaN(new Date(this.data.EndDate).getDate()) ? 1 : 0;
    this.validateDateRange();
  }

  validateDateRange() {
    if (this.validator.StartDate === 1 && this.validator.EndDate === 1){
      this.validator.DateRange = this.data.StartDate <= this.data.EndDate ? 1 : 0;
    }
    else this.validator.DateRange = -1;
  }

  getAssignedStudentsText(): string {
    let assignedStudentsCount = this.assignedStudents.filter(s => s.include).length;

    if (assignedStudentsCount == 1) return "1 Student";
    if (assignedStudentsCount > 1) return `${assignedStudentsCount} Students`;
    return "All Students";
  }

  allStudentsAssigned(): boolean {
    return !this.assignedStudents.some(s => s.include);
  }

  assignToAllStudents() {
    this.assignedStudents.forEach(s => s.include = false);
  }

  toggleStudent(student: any): void {
    student.include = !student.include;
  }

  saveAssignedStudents() {
    this.assignedStudentsOld = JSON.parse(JSON.stringify(this.assignedStudents));
  }

  cancelAssignedStudents() {
    this.assignedStudents = JSON.parse(JSON.stringify(this.assignedStudentsOld));
  }

  ngOnInit() {
  }

}
